import { ClientActingUser } from '@/auth/useSession';
import { ShouldRenderPredicate } from '@/routes/_layout/-components/nav-link';

export const shouldRenderItem = (
  actingUser: ClientActingUser,
  shouldRender?: ShouldRenderPredicate | ShouldRenderPredicate[],
) => {
  return shouldRender
    ? Array.isArray(shouldRender)
      ? shouldRender.some((fn) => fn(actingUser))
      : shouldRender(actingUser)
    : true;
};
